import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { TranslocoService } from '@ngneat/transloco';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-worker-ihelp',
  templateUrl: './worker-ihelp.component.html',
  styleUrls: ['./worker-ihelp.component.scss']
})
export class WorkerIhelpComponent implements OnInit {

  @Input() worker:any;

  formGroup = new FormGroup({
    ihelp: new FormControl('',[])
  });

  submitted = false;

  @Output() refreshWorker = new EventEmitter();

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    //console.log('worker',this.worker);

    this.setForm();

  }

  setForm(){
    this.formGroup.setValue({
      ihelp: this.worker.ihelp
    });
    //console.log(this.formGroup.value);
  }

  submitForm(){

    this.submitted = true;

    if(this.formGroup.valid){
      let values = this.formGroup.value;
      //console.log('values',values);
      this.okService.put("workers/"+this.worker.id,values)
      .subscribe((data) => {

        this.worker = data.body;
        this.setForm();
        this.refreshWorker.emit();

        this.okService.setAlert(this.transloco.translate("Your iHelp device has been updated"),"success");


      });

    }

    return false;

  }

}
